export default __webpack_public_path__ + "static/media/qr-scan 1.7abf39fd.svg";